import {Component, OnInit} from '@angular/core';
import {ShipmentsService} from "../services/shipments.service";
import {ActivatedRoute} from "@angular/router";
import {ShipmentsModalComponent} from "../shipments-modal/shipments-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-picking-lists',
    templateUrl: './picking-lists.component.html',
    styleUrls: ['./picking-lists.component.scss']
})
export class PickingListsComponent implements OnInit {
    protected pickingLists: any;
    private alert: string;
    private alertType: string;
    protected loading: boolean;
    pageNr: number;
    totalItems: number = null;

    constructor(
        public shipmentsService: ShipmentsService, public activatedRoute: ActivatedRoute,  public ngbModal: NgbModal) {

        this.activatedRoute.queryParams.subscribe(result => {
            if (result.page) {
                this.pageNr = parseInt(result?.page, 10)
            } else {
                this.pageNr = 1;
            }

            this.getPickingLists()
        });

    }

    ngOnInit(): void {
    }


    getPickingLists() {
        this.loading = true;
        this.shipmentsService.getPickingLists(this.pageNr).subscribe((response: any) => {
            this.totalItems = response.count;
            this.pickingLists = response.results.map((pickingList)=> {
              const  totalLines = pickingList.shipments.reduce((sum, shipment) => {
                    return sum + (shipment.shipment_product_lines ? shipment.shipment_product_lines.length : 0);
                }, 0);
             const   totalQt = pickingList.shipments.reduce((sum, shipment) => {
                    // tslint:disable-next-line:max-line-length
                    return sum + (shipment.shipment_product_lines ? shipment.shipment_product_lines.reduce((sum, line) => sum + line.amount, 0) : 0);
                }, 0);
                pickingList._totalLines = totalLines;
                pickingList._totalQt = totalQt;
                return pickingList;
            })
            this.loading = false;
        }, () => {
            this.loading = false;
            this.pickingLists = null;
            this.alert = 'Pluklister kunne ikke hentes';
            this.alertType = 'danger';
        });
    }

    protected showShipmentsModal(pickingList: any) {
        const modalRef = this.ngbModal.open(ShipmentsModalComponent, {size: 'xl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipments = pickingList.shipments;
    }
}
